import * as React from "react";
import { checkIcon, declineIcon } from "../icons";
import "../styles/summary.css";

interface ReviewSummaryProps {
  total: number;
  pending: number;
  accepted: number;
  declined: number;
  onAcceptAll: () => void;
  onDeclineAll: () => void;
}

const ReviewSummary: React.FC<ReviewSummaryProps> = ({ total, pending, accepted, declined, onAcceptAll, onDeclineAll }) => {
  const className = `review-summary${total > 0 ? " active" : ""}`;
  return (
    <div className={className}>
      <div className="review-summary-header">
        <span className="review-summary-title">Document Review</span>
        <span className="review-summary-count" id="reviewCount">
          {total} suggestions
        </span>
      </div>
      <div className="review-stats">
        <div className="review-stat">
          <span className="review-stat-dot pending" />
          <span id="pendingCount">{pending} pending</span>
        </div>
        <div className="review-stat">
          <span className="review-stat-dot accepted" />
          <span id="acceptedCount">{accepted} accepted</span>
        </div>
        <div className="review-stat">
          <span className="review-stat-dot declined" />
          <span id="declinedCount">{declined} declined</span>
        </div>
      </div>
      {pending > 0 && (
        <div className="review-actions-bar">
          <button className="review-action-btn accept-all" onClick={onAcceptAll}>
            {checkIcon}
            Accept All
          </button>
          <button className="review-action-btn decline-all" onClick={onDeclineAll}>
            {declineIcon}
            Decline All
          </button>
        </div>
      )}
    </div>
  );
};

export default ReviewSummary;
